module.exports = __webpack_public_path__ + "img/bobsled2.7bcc0a2a.jpg";